<template>
  <div>
    <!-- 卡片视图区域 -->
    <el-card>
      <!-- 搜索与添加区域 -->
      <el-row :gutter="20">
        <el-col :span="8">
          <el-input placeholder="请输入内容" v-model="queryInfo" clearable @clear="getMenuList">
            <el-button slot="append" icon="el-icon-search" @click="getMenuList"></el-button>
          </el-input>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" @click="addMenuList">添加菜单</el-button>
        </el-col>
      </el-row>

      <!-- 菜单列表区域 -->
      <el-table
        :data="menulist"
        row-key="Id"
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
        border
        stripe>
        <el-table-column label="菜单名称" prop="Title"></el-table-column>
        <el-table-column label="排序" prop="Weigh"></el-table-column>
        <el-table-column label="状态" prop="Status">
          <template slot-scope="scope">
            <span v-if="scope.row.Status == '0'">停用</span>
            <span v-if="scope.row.Status == '1'">正常</span>
          </template>
        </el-table-column>

        <el-table-column label="创建时间" prop="UpdatedAt"></el-table-column>
        <el-table-column label="备注" prop="Remark"></el-table-column>
        <el-table-column label="操作" width="180px">
          <template slot-scope="scope">
            <!-- 修改按钮 -->
            <el-tooltip effect="dark" content="修改" placement="top" :enterable="false">
              <el-button type="primary" icon="el-icon-edit" size="mini" @click="showEditDialog(scope.row.Id)"></el-button>
            </el-tooltip>
            <!-- 删除按钮 -->
            <el-tooltip effect="dark" content="删除" placement="top" :enterable="false">
              <el-button type="danger" icon="el-icon-delete" size="mini" @click="removeMenuById(scope.row)"></el-button>
            </el-tooltip>
            <!-- 新增按钮 -->
            <el-tooltip effect="dark" content="新增" placement="top" :enterable="false">
              <el-button type="warning" icon="el-icon-circle-plus-outline" size="mini" @click="setMenu(scope.row)"></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 添加菜单的对话框 -->
    <el-dialog title="添加菜单" :visible.sync="addDialogVisible" width="40%" @close="addDialogClosed">
      <!-- 内容主体区域 -->
      <el-form :model="addForm" :rules="addFormRules" ref="addFormRef" label-width="90px">
        <el-form-item label="上级菜单" prop="value" label-width="120px">
          <el-select ref="elSelect" class="width-100" v-model="addForm.value" placeholder="请选择">
            <el-option
              :value="addForm.value"
              style="height: auto"
            >
              <el-tree
                :data="menuListInfo"
                node-key="Id"
                :props="defaultProps"
                @node-click="handleNodeClick"
              ></el-tree>
            </el-option>
          </el-select>
        </el-form-item>
          <el-form-item label="菜单类型" prop="MenuType" label-width="120px">
            <el-radio-group v-model="addForm.MenuType">
              <el-radio label="1">目录</el-radio>
              <el-radio label="0">菜单</el-radio>
              <el-radio label="2">按钮</el-radio>
            </el-radio-group>
          </el-form-item>

        <el-row >
          <el-col :span="12">
            <el-form-item label="菜单名称" prop="Title" label-width="120px">
              <el-input v-model="addForm.Title"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="addForm.MenuType != 2">
            <el-form-item label="菜单状态" prop="Status">
              <el-radio-group v-model="addForm.Status">
                <el-radio label="1">正常</el-radio>
                <el-radio label="0">停用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="前端路由地址" prop="Path" label-width="120px">
          <el-input v-model="addForm.Component"></el-input>
        </el-form-item>
        <el-form-item label="后端路由地址" prop="Path" label-width="120px">
          <el-input v-model="addForm.Path"></el-input>
        </el-form-item>
      </el-form>
      <!-- 底部区域 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addMenu">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 修改菜单的对话框 -->
    <el-dialog title="修改菜单" :visible.sync="editDialogVisible" width="40%" @close="editDialogClosed">
      <!-- 内容主体区域 -->
      <el-form :model="editForm" :rules="editFormRules" ref="editFormRef" label-width="90px">
        <el-form-item label="上级菜单" prop="Ptitle" label-width="120px">
          <el-select ref="elSelect1" class="width-100" v-model="editForm.Ptitle" placeholder="请选择">
            <el-option
              :value="editForm.Ptitle"
              style="height: auto"
            >
              <el-tree
                :data="menuListInfo"
                node-key="Id"
                :props="defaultProps"
                @node-click="handleNodeClick1"
              ></el-tree>
            </el-option>
          </el-select>
        </el-form-item>
            <el-form-item label="菜单类型" prop="MenuType" label-width="120px">
              <el-radio-group v-model="editForm.MenuType">
                <el-radio :label="1">目录</el-radio>
                <el-radio :label="0">菜单</el-radio>
                <el-radio :label="2">按钮</el-radio>
              </el-radio-group>
            </el-form-item>

        <el-row >
          <el-col :span="12">
            <el-form-item label="菜单名称" prop="Title" label-width="120px">
              <el-input v-model="editForm.Title"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="editForm.MenuType != 2">
            <el-form-item label="菜单状态" prop="Status">
              <el-radio-group v-model="editForm.Status">
                <el-radio :label="1">正常</el-radio>
                <el-radio :label="0">停用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="前端路由地址" prop="Path" label-width="120px">
          <el-input v-model="editForm.Component"></el-input>
        </el-form-item>
        <el-form-item label="后端路由地址" prop="Path" label-width="120px">
          <el-input v-model="editForm.Path"></el-input>
        </el-form-item>


      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="editMenuInfo">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import { chat_get, chat_post, toForm } from '@/api'
  export default {
    inject: ['reload'],
    data() {
      return {
        menuListInfo: [],
        // 树形控件的配置
        defaultProps: {
          children: 'children',
          label: 'Title'
        },
        menulist: [],
        // 控制添加菜单对话框的显示与隐藏
        addDialogVisible: false,
        // 添加菜单的表单数据
        addForm: {
          value: '',
          MenuType: '1',
          Pid: 0,
          Path: '',
          Weigh: 0,
          Title: '',
          Status: '1',
          Component: ''
        },
        queryInfo: '',
        // 添加表单的验证规则对象
        addFormRules: {
          Title: [
            { required: true, message: '请输入菜单名称', trigger: 'blur' },
            {
              min: 2,
              max: 60,
              message: '菜单名称的长度在2~60个字符之间',
              trigger: 'blur'
            }
          ],
          Path: [
            { required: true, message: '请输入路由地址', trigger: 'blur' },
            {
              min: 2,
              max: 60,
              message: '路由地址的长度在2~30个字符之间',
              trigger: 'blur'
            }
          ],
          Weigh: [
            { required: true, message: '显示排序不能为空', trigger: 'blur' },
          ]
        },
        // 控制修改菜单对话框的显示与隐藏
        editDialogVisible: false,
        // 查询到的菜单信息对象
        editForm: {},
        // 修改表单的验证规则对象
        editFormRules: {
          Title: [
            { required: true, message: '请输入菜单名称', trigger: 'blur' },
            {
              min: 2,
              max: 60,
              message: '菜单名称的长度在2~60个字符之间',
              trigger: 'blur'
            }
          ],
          Path: [
            { required: true, message: '请输入路由地址', trigger: 'blur' },
            {
              min: 2,
              max: 60,
              message: '路由地址的长度在2~30个字符之间',
              trigger: 'blur'
            }
          ],
          Weigh: [
            { required: true, message: '显示排序不能为空', trigger: 'blur' },
          ]
        },
      }
    },
    created() {
      this.getMenuList()
    },
    methods: {
      getMenuSelection() {
        let vm = this;
        chat_get('/admin/v1/queryMenuDirectoryList', {} , res => {
          if(res.status == 200) {
            vm.menuListInfo = [{ Id: 0, Title: '主类目', children: res.data.MessageContent }];
          }
        })
      },
      addMenuList() {
        this.addDialogVisible = true
        this.getMenuSelection()
      },
      getMenuList() {
        chat_get(`/admin/v1/menu`, {}, res => {
          if(res.status == 200) {
            this.menulist = res.data.MessageContent
          }
        })
      },
      handleNodeClick(val) {
        this.addForm.Pid = val.Id
        this.addForm.value = val.Title
        this.$refs.elSelect.blur()
      },
      handleNodeClick1(val) {
        this.editForm.Pid = val.Id
        this.editForm.Ptitle = val.Title
        this.$refs.elSelect1.blur()
      },
      // 监听添加菜单对话框的关闭事件
      addDialogClosed() {
        this.$refs.addFormRef.resetFields()
      },
      // 点击按钮，添加新菜单
      addMenu() {
        this.$refs.addFormRef.validate(valid => {
          if (!valid) return
          let params = toForm(this.addForm)
          chat_post('/admin/v1/addMenu', params, res => {
            if(res.status == 200) {
              this.$message.success('添加菜单成功！')
              // 隐藏添加菜单的对话框
              this.addDialogVisible = false
              // 重新获取菜单列表数据
              this.getMenuList()
              this.reload();
            }
          })
        })
      },
      setMenu(val) {
        this.addForm.value = val.Title
        this.addForm.Pid = val.Id
        this.getMenuSelection();
        this.addDialogVisible = true

      },
      // 展示编辑菜单的对话框
      showEditDialog(id) {
        let vm = this;
        vm.getMenuSelection();
        chat_get(`/admin/v1/queryMenuById?Id=${id}`, {}, res => {
          if(res.status == 200) {
            vm.editForm = res.data.MessageContent
            vm.editForm.Ptitle = vm.editForm.Ptitle || '主类目'
          }
        })
        this.editDialogVisible = true
      },
      // 监听修改菜单对话框的关闭事件
      editDialogClosed() {
        this.$refs.editFormRef.resetFields()
      },
      // 添加菜单信息并提交
      editMenuInfo() {
        let vm = this;
        this.$refs.editFormRef.validate(valid => {
          if (!valid) return
          let { Id, Path, Title, MenuType, Pid, Status, Weigh, Component } = vm.editForm
          let params = toForm({
            Id,
            Pid,
            Path,
            MenuType,
            Title,
            Status,
            Weigh,
            Component
          })
          chat_post('/admin/v1/updateMenu', params, res => {
            if(res.status == 200) {
              // 关闭对话框
              vm.editDialogVisible = false
              // 刷新数据列表
              vm.getMenuList()
              // 提示修改成功
              vm.$message.success('更新菜单信息成功！')

              vm.reload();
            }
          })
        })
      },
      // 根据Id删除对应的菜单信息
      removeMenuById(oneUser) {
        let vm = this;
        this.$confirm( `此操作将删除菜单"${oneUser.Title}", 是否继续?`, '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          chat_post(`/admin/v1/deleteMenu?Id=${oneUser.Id}`, {}, res => {
            if(res.status == 200) {
              vm.reload();
              vm.getMenuList()
              vm.$message({
                type: 'success',
                message: `删除成功!`
              });
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          });
        });
      },
    }
  }
</script>

<style lang="less" scoped>
  .el-select-dropdown__item {
    padding: 0;
  }
</style>
